module.exports = __webpack_public_path__ + "static/textla_logo-4ad9443d086bf67836f400dddd6d0053.png";